import React from "react";
import Skeleton from "react-loading-skeleton";

const PendingDocumentModalSkeleton = _ => {
    return <div className="row" style={{height: "calc(100vh - 220px)"}}>
                <div className="col-lg-4 overflow-auto h-100">
                    <div className=" py-5">
                        <Skeleton height="40px" className="mb-5" count="3" />
                    </div>
                </div>
                <div className="col-lg-8 overflow-auto h-100 ">
                    <div className=" px-lg-5 py-5">
                        <div className="text-dark-50 line-height-lg">
                            {/* <!--end::Input--> */}
                            <Skeleton height="400px" className="mb-4" count="1"/>
                            <div className="row">
                                <div className="col-xl-6">
                                    <Skeleton height="50px" className="mb-4" count="4"/>
                                </div>
                                <div className="col-xl-6">
                                    <Skeleton height="50px" className="mb-4" count="4"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

}

export default PendingDocumentModalSkeleton;